export default "__VITE_ASSET__106309e5__"